export default {
  // Navigation
  nav_home: 'Inicio',
  nav_about: 'Quiénes Somos',
  nav_services: 'Servicios',
  nav_catalog: 'Suministros',
  nav_contact: 'Contacto',
  nav_quote: 'Cotizar 24/7',
  nav_menu: 'Menú',
  nav_close: 'Cerrar',
  nav_map: 'Mapa',
  nav_testimonials: 'Testimonios',

  // Hero
  hero_headline: 'Aprovisionamiento Naval de Clase Mundial',
  hero_subheadline: 'Desde 1975, operamos 24/7 en los 13 puertos estratégicos de México. Suministro integral, entrega puntual y logística sin fricción para flotas internacionales.',
  hero_cta_primary: 'Cotizar Ahora',
  hero_cta_secondary: 'Ver Servicios',
  hero_stat_years: '50+',
  hero_stat_years_label: 'Años de experiencia',
  hero_stat_ports: '13',
  hero_stat_ports_label: 'Puertos de cobertura',
  hero_stat_247: '24/7',
  hero_stat_247_label: 'Disponibilidad operativa',
  hero_scroll: 'Descubre nuestras soluciones',
  hero_coverage_title: 'Cobertura Nacional',
  hero_coverage_subtitle: '13 puertos estratégicos de México',

  // About
  about_tag: 'Quiénes Somos',
  about_headline: '50 años de experiencia operando los puertos de México',
  about_body_1: 'Fundada en 1975, Avimar Ship Chandlers nació como respuesta a la creciente demanda de aprovisionamiento naval en el puerto de Coatzacoalcos. Hoy, cinco décadas después, somos una empresa multimodal con presencia operativa en los 13 puertos estratégicos del país: del Pacífico al Golfo de México.',
  about_body_2: 'Nuestra evolución no ha sido lineal. Hemos transitado desde el abastecimiento básico de buques hasta soluciones portuarias integrales que incluyen lanchaje, almacenamiento, gestión de residuos y representación consignataria.',
  about_body_3: 'Contamos con vehículos refrigerados, grúas propias y personal altamente calificado. No delegamos: controlamos la cadena de suministro de inicio a fin.',
  about_cta: 'Conoce Nuestra Historia',
  about_stat_years: 'Años de trayectoria',
  about_stat_years_desc: 'Desde 1975, sin interrupción',
  about_stat_ports: 'Puertos en operación',
  about_stat_ports_desc: 'Cobertura nacional completa',
  about_stat_247: 'Disponibilidad total',
  about_stat_247_desc: 'Cualquier horario, cualquier día',
  about_hq_label: 'Sede Principal',
  about_hq_location: 'Coatzacoalcos, Veracruz',
  about_hq_caption: 'Centro de operaciones logísticas con flota propia',

  // Services
  services_tag: 'Servicios Multimodales',
  services_headline: 'Soluciones portuarias integrales para cualquier escala de operación',
  services_subheadline: 'Desde el avituallamiento de una embarcación hasta la logística de una flota completa. Cada servicio está diseñado para reducir tiempo de puerto y maximizar eficiencia operativa.',
  services_cta: 'Ver Servicios',
  service_avituallamiento: 'Avituallamiento',
  service_avituallamiento_desc: 'Suministro de provisiones, consumibles de cabina y artículos de cubierta con entrega directa a bordo. Flota refrigerada propia para garantizar cadena de frío.',
  service_lanchaje: 'Lanchaje',
  service_lanchaje_desc: 'Transporte de personal, tripulación y carga entre buques y puerto mediante embarcaciones rápidas y seguras.',
  service_reparaciones: 'Reparaciones Navales',
  service_reparaciones_desc: 'Servicio de reparación y mantenimiento de barcos en puerto. Equipo técnico calificado para intervenciones rápidas.',
  service_almacenamiento: 'Almacenamiento',
  service_almacenamiento_desc: 'Bodegas portuarias con control de temperatura y seguridad para el resguardo de mercancía antes de embarque.',
  service_residuos: 'Recolección de Residuos',
  service_residuos_desc: 'Gestión integral de basura y residuos de buques conforme a normativas MARPOL.',
  service_agencia: 'Agencia Consignataria',
  service_agencia_desc: 'Representación oficial de buques ante autoridades portuarias, aduaneras y migratorias.',
  services_highlight_delivery: 'Entrega directa a bordo',
  services_highlight_cold: 'Cadena de frío garantizada',
  services_highlight_stock: 'Stock de emergencia 24/7',
  services_highlight_crew: 'Transporte de tripulación',
  services_highlight_docs: 'Carga liviana y documentos',
  services_highlight_weather: 'Operación bajo cualquier clima',
  services_highlight_maintenance: 'Mantenimiento preventivo',
  services_highlight_urgent: 'Reparaciones urgentes',
  services_highlight_certified: 'Personal técnico certificado',
  services_highlight_temp: 'Control de temperatura',
  services_highlight_digital: 'Inventario digitalizado',
  services_highlight_security: 'Seguridad 24/7',
  services_highlight_marpol: 'Cumplimiento MARPOL',
  services_highlight_docs_port: 'Documentación portuaria',
  services_highlight_scheduled: 'Recolección programada',
  services_highlight_clearance: 'Trámites portuarios',
  services_highlight_dispatch: 'Despacho de tripulación',
  services_highlight_permits: 'Permisos y zarpe',

  // Supplies
  supplies_tag: 'Chandlering Naval',
  supplies_headline: 'Suministros náuticos certificados para la operación de tu flota',
  supplies_intro: 'Como ship chandler con 50 años de trayectoria, no distribuimos insumos genéricos. Cada artículo en nuestro catálogo está seleccionado específicamente para operaciones a bordo: desde provisiones frescas para la tripulación hasta equipo de salvamento homologado bajo normativa IMO. Auditamos cada proveedor, verificamos lotes antes de embarque y mantenemos cadena de frío documentada de puerta a bordo.',
  supplies_cta: 'Explorar Catálogo de Chandler',
  supplies_category_provisiones: 'Provisiones para Bordo',
  supplies_category_provisiones_desc: 'Carnes rojas, cortes americanos, carnes frías, pescados frescos, frutas y verduras, congelados, bebidas, abarrotes y artículos personales para tripulación. Entrega directa a bordo con flota refrigerada.',
  supplies_category_consumibles: 'Consumibles de Cabina y Puente',
  supplies_category_consumibles_desc: 'Utensilios de cocina y bar, artículos de escritorio, equipos médicos de a bordo, consumibles de limpieza, línea blanca, higiene personal y ferretería de cabina para el confort de la tripulación.',
  supplies_category_cubierta: 'Cubierta, Máquinas y Seguridad',
  supplies_category_cubierta_desc: 'Cabos marinos, equipo de carga y estiba, mangueras industriales, lubricantes marinos, herramientas, tubería, válvulas, baleros, equipo de soldadura y material eléctrico para mantenimiento a bordo.',
  supplies_category_cartas: 'Cartas Náuticas y Publicaciones IMO',
  supplies_category_cartas_desc: 'Cartas británicas, americanas USCG, japonesas, australianas y canadienses. Avisos a marinos, tablas de mareas, lista de señales y publicaciones de navegación obligatorias para cumplimiento.',
  supplies_category_salvamento: 'Equipo de Salvamento IMO',
  supplies_category_salvamento_desc: 'Raciones de emergencia, silbatos, reflectores radar, cinta reflectante, chalecos salvavidas homologados, botiquines, aros, extinguidores y mangueras contra incendios certificados.',
  supplies_category_pirotecnia: 'Pirotecnia de Emergencia',
  supplies_category_pirotecnia_desc: 'Señales con paracaídas, bengalas de humo, bengalas de mano, señal de hombre al agua, lanza cabos y boyas automáticas con señal de humo y luz conforme a regulación SOLAS.',
  supplies_tag_fresh: 'Fresh',
  supplies_tag_cabin: 'Cabin',
  supplies_tag_deck: 'Deck',
  supplies_tag_navigational: 'Navigational',
  supplies_tag_safety: 'Safety',
  supplies_tag_emergency: 'Emergency',

  // Testimonials
  testimonials_tag: 'Clientes y Alianzas',
  testimonials_headline: 'Navieras internacionales que confían en nuestra operación',
  testimonials_subheadline: 'La confianza de nuestros clientes no se solicita: se construye con cada entrega puntual.',
  testimonials_quote_1: 'En Avimar encontramos lo que no da la competencia: respuesta en menos de 2 horas y entrega exacta a lo solicitado. Llevamos 8 años operando con ellos en Coatzacoalcos y Veracruz.',
  testimonials_author_1: 'Capt. James Morrison',
  testimonials_role_1: 'Gerente de Operaciones',
  testimonials_company_1: 'Pacific Maritime Services Ltd.',
  testimonials_quote_2: 'Su capacidad de lanchaje en condiciones adversas nos salvó un despacho crítico. No es un proveedor: es un aliado operativo en cada puerto mexicano donde atracamos.',
  testimonials_author_2: 'Elena Vásquez',
  testimonials_role_2: 'Directora de Compras',
  testimonials_company_2: 'TransOceanic Logistics Group',
  testimonials_quote_3: 'El control de calidad de sus provisiones es riguroso. Nunca hemos tenido una devolución por producto en mal estado. Su cadena de frío es impecable.',
  testimonials_author_3: 'Michael Chen',
  testimonials_role_3: 'Superintendente de Flota',
  testimonials_company_3: 'Global Seaways Corporation',
  testimonials_quote_4: 'Desde que empezamos a usar su servicio de agencia consignataria, redujimos los tiempos de trámite portuario en un 40%.',
  testimonials_author_4: 'Ana Lucía Herrera',
  testimonials_role_4: 'Agente Consignataria',
  testimonials_company_4: 'Marina del Norte S.A.',
  testimonials_quote_5: 'La recolección de residuos con documentación MARPOL completa nos da tranquilidad ante autoridades. Su cumplimiento normativo es ejemplar.',
  testimonials_author_5: 'Robert K. Andersen',
  testimonials_role_5: 'Oficial de Cumplimiento Ambiental',
  testimonials_company_5: 'Nordic Shipping Alliance',
  testimonials_quote_6: 'Su stock de cartas náuticas y publicaciones es el más completo que hemos encontrado en México. Siempre tienen la edición más reciente.',
  testimonials_author_6: 'Francisco Delgado',
  testimonials_role_6: 'Oficial de Navegación',
  testimonials_company_6: 'Ibero-American Shipping Co.',

  // CTA
  cta_available_now: 'Disponible Ahora',
  cta_trust_247: 'Operación 24/7',
  cta_trust_iso: 'Estándares ISO',
  cta_trust_response: 'Respuesta < 1h',
  cta_headline: 'Tu operación no espera. Nosotros tampoco.',
  cta_subheadline: 'Cotiza tu aprovisionamiento en menos de 1 hora.',
  cta_button: 'Solicitar Cotización 24/7',
  cta_footer_headline: 'Tu operación portuaria no espera. Nosotros tampoco.',

  // Strategy
  strategy_tag: 'Estrategia Multimodal',
  strategy_headline: 'Operación integrada de punta a punta en cada puerto',
  strategy_subheadline: 'Cuatro pilares operativos que garantizan la continuidad de tu flota sin importar el puerto, la escala o la urgencia.',
  strategy_logistica_title: 'Logística Portuaria',
  strategy_logistica_desc: 'Coordinación de suministro en 13 puertos estratégicos con flota propia y seguimiento en tiempo real de cada entrega.',
  strategy_logistica_stat: 'Puertos Activos',
  strategy_logistica_highlight: 'Cobertura Pacífico y Golfo',
  strategy_suministros_title: 'Suministros Críticos',
  strategy_suministros_desc: 'Seis líneas de suministro certificadas: desde provisiones frescas hasta equipo de salvamento y pirotecnia de emergencia.',
  strategy_suministros_stat: 'Categorías',
  strategy_suministros_highlight: 'Calidad auditada por lote',
  strategy_reparaciones_title: 'Reparaciones Navales',
  strategy_reparaciones_desc: 'Intervención técnica en puerto con personal certificado. Mantenimiento preventivo y reparaciones urgentes sin movimiento del buque.',
  strategy_reparaciones_stat: 'Tiempo de respuesta',
  strategy_reparaciones_highlight: 'Intervención sin movimiento',
  strategy_residuos_title: 'Gestión de Residuos',
  strategy_residuos_desc: 'Recolección y disposición conforme a MARPOL con documentación completa para autoridades portuarias y ambientales.',
  strategy_residuos_stat: 'Cumplimiento normativo',
  strategy_residuos_highlight: 'Documentación MARPOL completa',

  // Ports
  ports_tag: 'Presencia Nacional',
  ports_headline: 'Cobertura operativa en los 13 puertos estratégicos de México',
  ports_subheadline: 'Desde Manzanillo en el Pacífico hasta Progreso en el Golfo de México. Tu flota nunca estará fuera de nuestro alcance.',
  ports_pacific_title: 'Océano Pacífico',
  ports_gulf_title: 'Golfo de México',

  // Certifications
  cert_247_title: 'Operación 24/7',
  cert_247_desc: 'Personal y flota disponibles cualquier día del año, incluyendo festivos y condiciones climáticas adversas.',
  cert_iso_title: 'Estándares ISO',
  cert_iso_desc: 'Procesos de calidad documentados y cadena de suministro trazable con control de lote por lote.',
  cert_safety_title: 'Seguridad Industrial',
  cert_safety_desc: 'Equipo de protección personal obligatorio, protocolos de seguridad portuaria y capacitación continua.',
  cert_response_title: 'Respuesta Inmediata',
  cert_response_desc: 'Tiempo de respuesta promedio inferior a 60 minutos para cotizaciones y despachos urgentes.',

  // Gallery
  gallery_tag: 'Operaciones Reales',
  gallery_headline: 'Infraestructura en Acción',
  gallery_subheadline: 'Bodegas climatizadas, gestión de residuos certificada y talleres de reparación naval. Esto es lo que hacemos a diario.',
  gallery_tab_storage: 'Almacenamiento',
  gallery_tab_waste: 'Recolección de Residuos',
  gallery_tab_repair: 'Reparación de Barcos',

  // Map
  map_tag: 'Cobertura Nacional',
  map_headline: '13 Puertos, 2 Costas, 1 Operador',
  map_subheadline: 'Desde Manzanillo en el Pacífico hasta Progreso en el Golfo. Marcamos la diferencia en cada puerto donde atraca tu flota.',
  map_popup_hub: 'Avimar Hub',

  // Footer
  footer_tagline: 'Soluciones portuarias, marítimas e industriales desde 1975.',
  footer_description: 'Empresa multimodal mexicana con presencia en los 13 principales puertos del país.',
  footer_address: 'Calzada al Sumidero S/N, Zona Industrial, Coatzacoalcos, Veracruz, 96400, México',
  footer_phone: 'Teléfono: +52 921 218 3400',
  footer_email: 'Correo: contacto@avimarshipchandlers.com',
  footer_hours: 'Horario: 24 horas / 7 días',
  footer_nav_title: 'Navegación',
  footer_services_title: 'Servicios',
  footer_ports_title: 'Puertos de Cobertura',
  footer_ports_pacific: 'Océano Pacífico',
  footer_ports_gulf: 'Golfo de México',
  footer_newsletter_title: 'Mantente informado',
  footer_newsletter_placeholder: 'Tu correo electrónico',
  footer_newsletter_button: 'Suscribirse',
  footer_newsletter_hint: 'Recibe noticias de operaciones y actualizaciones de cobertura portuaria.',
  footer_copyright: '© 2026 Avimar Ship Chandlers. Todos los derechos reservados.',
  footer_privacy: 'Aviso de Privacidad',
  footer_terms: 'Términos de Servicio',
  footer_brand_marquee: 'AVIMAR SHIP CHANDLERS',
};